import { render, staticRenderFns } from "./file-up-down.vue?vue&type=template&id=f299b83c"
import script from "./file-up-down.vue?vue&type=script&lang=js"
export * from "./file-up-down.vue?vue&type=script&lang=js"
import style0 from "./file-up-down.vue?vue&type=style&index=0&id=f299b83c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports